import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  Typography,
  Autocomplete,
  TextField,
} from '@mui/material'
import React, { useState } from 'react'
import moment from 'moment'

const AssignJourneyModal = ({
  open,
  onClose,
  duties,
  onConfirm,
  setOpenCreateDuty,
}) => {
  const [selectedDuty, setSelectedDuty] = useState(null)
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Assign Journey</DialogTitle>
      {duties.length === 0 ? (
        <DialogContent>
          <Typography variant="body2">
            There are no Duties available yet.
          </Typography>
        </DialogContent>
      ) : (
        <DialogContent>
          <Typography variant="body2" mb={1}>
            Choose a duty to assign this journey to:
          </Typography>
          <Autocomplete
            value={selectedDuty}
            isOptionEqualToValue={(option, value) => {
              return option._id === value._id
            }}
            onChange={(e, newValue) => setSelectedDuty(newValue)}
            fullWidth
            renderInput={(params) => <TextField {...params} label="Duty" />}
            getOptionLabel={(opt) =>
              `${opt.vehicle?.callSign ?? 'No Vehicle'} (${moment(
                opt.start
              ).format('HH:mm')}–${moment(opt.end).format('HH:mm')})`
            }
            getOptionDisabled={(opt) => opt.vehicle?.isBusy}
            options={duties}
            getOptionKey={(opt) => opt._id}
          />
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {duties.length === 0 ? (
          <Button
            variant="contained"
            color="anPurple"
            onClick={() => {
              setOpenCreateDuty(true)
            }}
          >
            Create a Duty
          </Button>
        ) : (
          <Button
            variant="contained"
            color="anBlue"
            disabled={!selectedDuty}
            onClick={() => onConfirm(selectedDuty)}
          >
            Assign
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default AssignJourneyModal
